import type { TierItem } from "../pages/components/tierList";

export const museumList: TierItem[] = [
    { name: "Strataca (Kansas Underground Salt Museum) — Hutchinson, KS", tier: "S" },
    { name: "History of Diving Museum — Islamorada, FL", tier: "S" },
    { name: "California State Railroad Museum — Sacramento, CA", tier: "S" },
    { name: "National Museum of the U.S. Air Force — Dayton, OH", tier: "S" },
    { name: "American Sign Museum — Cincinnati, OH", tier: "S" },
    { name: "Museum of the Bible — Washington, D.C.", tier: "S" },
    { name: "Musical Instrument Museum — Phoenix, AZ", tier: "S" },
    { name: "Museum of Osteology — Oklahoma City, OK", tier: "S" },

    { name: "The National Museum of Toys and Miniatures — Kansas City, MO", tier: "B" },
    { name: "Pioneer Village — Minden, NE", tier: "C" },
    { name: "The Archway — Kearney, NE", tier: "B" },
    { name: "Kiewit Luminarium — Omaha, NE", tier: "C" },
    { name: "The Durham Museum — Omaha, NE", tier: "B" },
    { name: "Joslyn Castle & Gardens — Omaha, NE", tier: "C" },
    { name: "Morrill Hall (University of Nebraska State Museum) — Lincoln, NE", tier: "C" },
    { name: "Museum of Pop Culture (MoPOP) — Seattle, WA", tier: "C" },
    { name: "Seattle Pinball Museum — Seattle, WA", tier: "C" },
    { name: "Portland Art Museum — Portland, OR", tier: "B" },
    { name: "Denver Art Museum — Denver, CO", tier: "B" },
    { name: "Selfie Museum — Denver, CO", tier: "A" },
    { name: "Wings Over the Rockies Air & Space Museum — Denver, CO", tier: "A" },

    { name: "National Cowboy & Western Heritage Museum — Oklahoma City, OK", tier: "A" },
    { name: "Titanic Museum Attraction — Branson, MO", tier: "C" },
    { name: "National WWI Museum and Memorial — Kansas City, MO", tier: "A" },
    { name: "Mill City Museum — Minneapolis, MN", tier: "B" },
    { name: "Minneapolis Institute of Art — Minneapolis, MN", tier: "C" },
    { name: "Griffin Museum of Science and Industry — Chicago, IL", tier: "A" },
    { name: "Art Institute of Chicago — Chicago, IL", tier: "A" },
    { name: "Field Museum — Chicago, IL", tier: "A" },
    { name: "Isabella Stewart Gardner Museum — Boston, MA", tier: "C" },
    { name: "Museum of Fine Arts — Boston, MA", tier: "C" },
    { name: "New Bedford Whaling Museum — New Bedford, MA", tier: "S" },
    { name: "Newport Car Museum — Portsmouth, RI", tier: "B" },
    { name: "New England Ski Museum — Franconia, NH", tier: "C" },
    { name: "New England Pirate Museum — Salem, MA", tier: "C" },
    { name: "Peabody Essex Museum — Salem, MA", tier: "C" },
    { name: "Des Moines Art Center — Des Moines, IA", tier: "C" },
    { name: "Pirates Treasure Museum — St. Thomas, U.S. Virgin Islands", tier: "C" },
    { name: "Paradox Museum Miami — Miami, FL", tier: "B" },

    { name: "National Museum of Nuclear Science & History — Albuquerque, NM", tier: "A" },
    { name: "Route 66 Auto Museum — Santa Rosa, NM", tier: "B" },

    { name: "Southern Food & Beverage Museum — New Orleans, LA", tier: "A" },
    { name: "New Orleans Pharmacy Museum — New Orleans, LA", tier: "A" },
    { name: "New Orleans Historic Voodoo Museum — New Orleans, LA", tier: "C" },
    { name: "Mississippi Civil Rights Museum — Jackson, MS", tier: "C" },
    { name: "USS Alabama Battleship Memorial Park — Mobile, AL", tier: "S" },
    { name: "Mobile Carnival Museum — Mobile, AL", tier: "B" },
    { name: "The National WWII Museum — New Orleans, LA", tier: "B" },
    { name: "Civil War Museum — New Orleans, LA", tier: "C" },
    { name: "Museum of Death — New Orleans, LA", tier: "C" },
    { name: "Sturgis Motorcycle Museum & Hall of Fame — Sturgis, SD", tier: "B" },
    { name: "World of Coca-Cola — Atlanta, GA", tier: "C" },
    { name: "Salt & Pepper Shaker Museum — Gatlinburg, TN", tier: "A" },
    { name: "Country Music Hall of Fame and Museum — Nashville, TN", tier: "A" },
    { name: "Johnny Cash Museum — Nashville, TN", tier: "B" },

    { name: "Petersen Automotive Museum — Los Angeles, CA", tier: "A" },
    { name: "1940 Air Terminal Museum — Houston, TX", tier: "B" },
    { name: "The Health Museum — Houston, TX", tier: "C" },
    { name: "Holocaust Museum Houston — Houston, TX", tier: "C" },
    { name: "Space Center Houston — Houston, TX", tier: "C" },
    { name: "National Museum of Funeral History — Houston, TX", tier: "S" },
    { name: "Louisville Slugger Museum & Factory — Louisville, KY", tier: "S" },
    { name: "Kentucky Derby Museum — Louisville, KY", tier: "S" },
    { name: "Beckley Exhibition Coal Mine — Beckley, WV", tier: "S" },

    { name: "International Spy Museum — Washington, D.C.", tier: "C" },

    { name: "Early Television Museum — Hilliard, OH", tier: "B" },

    { name: "Indianapolis Motor Speedway Museum — Indianapolis, IN", tier: "A" },
    { name: "Museum of Clean — Pocatello, ID", tier: "A" },
    { name: "Idaho Potato Museum — Blackfoot, ID", tier: "C" },
    { name: "World Museum of Mining — Butte, MT", tier: "B" },
    { name: "Iowa 80 Trucking Museum — Walcott, IA", tier: "A" },
    { name: "National Mustard Museum — Middleton, WI", tier: "C" },
    { name: "Circus World — Baraboo, WI", tier: "A" },
    { name: "National Fresh Water Fishing Hall of Fame — Hayward, WI", tier: "A" },
    { name: "William A. Irvin Museum — Duluth, MN", tier: "A" },
];